const TAGS = {
  FITNESS: "fitness",
  FOOD: "food",
  HAPPINESS: "happiness",
  HEALTH: "health",
  WELLNESS: "wellness",
}

const tagMap = {
  athleisure: TAGS.FITNESS,
  crossfit: TAGS.FITNESS,
  flexibility: TAGS.FITNESS,
  hiit: TAGS.FITNESS,
  hiking: TAGS.FITNESS,
  kundalini: TAGS.FITNESS,
  longevity: TAGS.FITNESS,
  pilates: TAGS.FITNESS,
  running: TAGS.FITNESS,
  swimming: TAGS.FITNESS,
  triathlon: TAGS.FITNESS,
  yoga: TAGS.FITNESS,
  gmo: TAGS.FOOD,
  paleo: TAGS.FOOD,
  rawfood: TAGS.FOOD,
  breakfast: TAGS.FOOD,
  cleanse: TAGS.FOOD,
  coffee: TAGS.FOOD,
  dessert: TAGS.FOOD,
  digestion: TAGS.FOOD,
  dinner: TAGS.FOOD,
  drinks: TAGS.FOOD,
  easymeals: TAGS.FOOD,
  fats: TAGS.FOOD,
  foodsensitivity: TAGS.FOOD,
  gluten: TAGS.FOOD,
  glutenfree: TAGS.FOOD,
  grainfree: TAGS.FOOD,
  intermittentfasting: TAGS.FOOD,
  kale: TAGS.FOOD,
  ketogenic: TAGS.FOOD,
  kombucha: TAGS.FOOD,
  lunch: TAGS.FOOD,
  organicfood: TAGS.FOOD,
  protein: TAGS.FOOD,
  restaurants: TAGS.FOOD,
  salads: TAGS.FOOD,
  smoothies: TAGS.FOOD,
  snacks: TAGS.FOOD,
  soup: TAGS.FOOD,
  sugar: TAGS.FOOD,
  sugarfree: TAGS.FOOD,
  superfoods: TAGS.FOOD,
  vegan: TAGS.FOOD,
  vegetarian: TAGS.FOOD,
  yogurt: TAGS.FOOD,
  affirmations: TAGS.HAPPINESS,
  anxiety: TAGS.HAPPINESS,
  breakup: TAGS.HAPPINESS,
  celebrity: TAGS.HAPPINESS,
  confidence: TAGS.HAPPINESS,
  dating: TAGS.HAPPINESS,
  divorce: TAGS.HAPPINESS,
  dogs: TAGS.HAPPINESS,
  empowerment: TAGS.HAPPINESS,
  fear: TAGS.HAPPINESS,
  feminism: TAGS.HAPPINESS,
  forgiveness: TAGS.HAPPINESS,
  friendship: TAGS.HAPPINESS,
  giftguide: TAGS.HAPPINESS,
  gratitude: TAGS.HAPPINESS,
  grief: TAGS.HAPPINESS,
  holiday: TAGS.HAPPINESS,
  journaling: TAGS.HAPPINESS,
  joy: TAGS.HAPPINESS,
  makeup: TAGS.HAPPINESS,
  marriage: TAGS.HAPPINESS,
  minimalism: TAGS.HAPPINESS,
  motherhood: TAGS.HAPPINESS,
  music: TAGS.HAPPINESS,
  singlelife: TAGS.HAPPINESS,
  singleparent: TAGS.HAPPINESS,
  soulmates: TAGS.HAPPINESS,
  toxicrelationships: TAGS.HAPPINESS,
  ayurveda: TAGS.HEALTH,
  traditionalchinesemedicine: TAGS.HEALTH,
  acne: TAGS.HEALTH,
  alcohol: TAGS.HEALTH,
  allergies: TAGS.HEALTH,
  asthma: TAGS.HEALTH,
  autoimmune: TAGS.HEALTH,
  bodypositivity: TAGS.HEALTH,
  brain: TAGS.HEALTH,
  breastfeeding: TAGS.HEALTH,
  budget: TAGS.HEALTH,
  cancer: TAGS.HEALTH,
  candida: TAGS.HEALTH,
  depression: TAGS.HEALTH,
  eatingdisorders: TAGS.HEALTH,
  energy: TAGS.HEALTH,
  fertility: TAGS.HEALTH,
  functionalnutrition: TAGS.HEALTH,
  greentea: TAGS.HEALTH,
  guthealth: TAGS.HEALTH,
  headaches: TAGS.HEALTH,
  hormones: TAGS.HEALTH,
  immunity: TAGS.HEALTH,
  inflammation: TAGS.HEALTH,
  libido: TAGS.HEALTH,
  metabolism: TAGS.HEALTH,
  microbiome: TAGS.HEALTH,
  mitochondria: TAGS.HEALTH,
  orgasm: TAGS.HEALTH,
  pregnancy: TAGS.HEALTH,
  probiotics: TAGS.HEALTH,
  skincare: TAGS.HEALTH,
  sleep: TAGS.HEALTH,
  stress: TAGS.HEALTH,
  supplements: TAGS.HEALTH,
  tea: TAGS.HEALTH,
  thyroid: TAGS.HEALTH,
  toxinsathome: TAGS.HEALTH,
  turmeric: TAGS.HEALTH,
  acupuncture: TAGS.WELLNESS,
  herbs: TAGS.WELLNESS,
  journey: TAGS.WELLNESS,
  purpose: TAGS.WELLNESS,
  aromatherapy: TAGS.WELLNESS,
  astrology: TAGS.WELLNESS,
  breath: TAGS.WELLNESS,
  chakras: TAGS.WELLNESS,
  climatechange: TAGS.WELLNESS,
  coconutoil: TAGS.WELLNESS,
  crystals: TAGS.WELLNESS,
  environmentalism: TAGS.WELLNESS,
  essentialoils: TAGS.WELLNESS,
  fengshui: TAGS.WELLNESS,
  manifesting: TAGS.WELLNESS,
  mantras: TAGS.WELLNESS,
  massage: TAGS.WELLNESS,
  news: TAGS.WELLNESS,
  newsroundup: TAGS.WELLNESS,
  organic: TAGS.WELLNESS,
  plants: TAGS.WELLNESS,
  politics: TAGS.WELLNESS,
  reiki: TAGS.WELLNESS,
  tantra: TAGS.WELLNESS,
  technology: TAGS.WELLNESS,
  personalgrowth: TAGS.WELLNESS,
  wellness: TAGS.WELLNESS,
  meditation: TAGS.WELLNESS,
  mindfulness: TAGS.WELLNESS,
  greenliving: TAGS.WELLNESS,
  abundance: TAGS.WELLNESS,
  spirituality: TAGS.WELLNESS,
  healing: TAGS.WELLNESS,
  selfcare: TAGS.WELLNESS,
  mindbodyconnection: TAGS.WELLNESS,
  holistichealing: TAGS.WELLNESS,
  parenting: TAGS.WELLNESS,
  skin: TAGS.WELLNESS,
  selfacceptance: TAGS.WELLNESS,
  stressmanagement: TAGS.WELLNESS,
  inspiration: TAGS.WELLNESS,
  meditationtricks: TAGS.WELLNESS,
  home: TAGS.WELLNESS,
  sustainability: TAGS.WELLNESS,
  career: TAGS.WELLNESS,
  goalsetting: TAGS.WELLNESS,
  bodyimage: TAGS.WELLNESS,
  mentalhealth: TAGS.WELLNESS,
  homedesigns: TAGS.WELLNESS,
  parentingadvice: TAGS.WELLNESS,
  video: TAGS.WELLNESS,
  sleeping: TAGS.WELLNESS,
  books: TAGS.WELLNESS,
  business: TAGS.WELLNESS,
  editorspick: TAGS.WELLNESS,
  breathing: TAGS.WELLNESS,
  mindfulnessmeditation: TAGS.WELLNESS,
  money: TAGS.WELLNESS,
  renewyou2017: TAGS.WELLNESS,
  tantricsex: TAGS.WELLNESS,
  pain: TAGS.WELLNESS,
  addiction: TAGS.WELLNESS,
  kids: TAGS.WELLNESS,
  mbgfeatures: TAGS.WELLNESS,
  howimeditate: TAGS.WELLNESS,
  olympics: TAGS.WELLNESS,
  intention: TAGS.WELLNESS,
  cleaningproducts: TAGS.WELLNESS,
  gardening: TAGS.WELLNESS,
  wellnesswonderwomen: TAGS.WELLNESS,
  ecofashion: TAGS.WELLNESS,
  newyeardoyou: TAGS.WELLNESS,
  visualization: TAGS.WELLNESS,
  lovehoroscope: TAGS.WELLNESS,
  alcoholism: TAGS.WELLNESS,
  change: TAGS.WELLNESS,
  balance: TAGS.WELLNESS,
  tips: TAGS.WELLNESS,
  friendshipadvice: TAGS.WELLNESS,
  funny: TAGS.WELLNESS,
  writing: TAGS.WELLNESS,
  newyorkcity: TAGS.WELLNESS,
  sexualassault: TAGS.WELLNESS,
  fengshuitips: TAGS.WELLNESS,
  greenergoods: TAGS.WELLNESS,
  awareness: TAGS.WELLNESS,
  transformation: TAGS.WELLNESS,
  kindness: TAGS.WELLNESS,
  infertility: TAGS.WELLNESS,
  halloween: TAGS.WELLNESS,
  anger: TAGS.WELLNESS,
  howtomeditate: TAGS.WELLNESS,
  posture: TAGS.WELLNESS,
  moneymonday: TAGS.WELLNESS,
  firstperson: TAGS.WELLNESS,
  simplicity: TAGS.WELLNESS,
  personalgrowthquotes: TAGS.WELLNESS,
  lifecoaching: TAGS.WELLNESS,
  spiritalmanac: TAGS.WELLNESS,
  vedic: TAGS.WELLNESS,
  greenclean: TAGS.WELLNESS,
  diystyle: TAGS.WELLNESS,
  authenticity: TAGS.WELLNESS,
  retreats: TAGS.WELLNESS,
  apps: TAGS.WELLNESS,
  holistichometour: TAGS.WELLNESS,
  sobriety: TAGS.WELLNESS,
  superbowlsunday: TAGS.WELLNESS,
  globalgreen: TAGS.WELLNESS,
  gender: TAGS.WELLNESS,
  sauna: TAGS.WELLNESS,
  celebrityyoga: TAGS.WELLNESS,
  listening: TAGS.WELLNESS,
  beautybites: TAGS.WELLNESS,
  ego: TAGS.WELLNESS,
  traininghowto: TAGS.WELLNESS,
  peace: TAGS.WELLNESS,
  cheating: TAGS.WELLNESS,
  parentingandyoga: TAGS.WELLNESS,
  cityguide: TAGS.WELLNESS,
  introvert: TAGS.WELLNESS,
  safety: TAGS.WELLNESS,
  seniors: TAGS.WELLNESS,
  ladygaga: TAGS.WELLNESS,
  pets: TAGS.WELLNESS,
  gwynethpaltrow: TAGS.WELLNESS,
  losangeles: TAGS.WELLNESS,
  starbucks: TAGS.WELLNESS,
  culture: TAGS.WELLNESS,
  vulnerability: TAGS.WELLNESS,
  inspirationaltypography: TAGS.WELLNESS,
  editorsletter: TAGS.WELLNESS,
  ecotravel: TAGS.WELLNESS,
  mantramonday: TAGS.WELLNESS,
  overheardinwellness: TAGS.WELLNESS,
  raisingconsciousness: TAGS.WELLNESS,
  abuse: TAGS.WELLNESS,
  cats: TAGS.WELLNESS,
  giselebundchen: TAGS.WELLNESS,
  acceptance: TAGS.WELLNESS,
  powerofpositivethinking: TAGS.WELLNESS,
  quizzes: TAGS.WELLNESS,
  diary: TAGS.WELLNESS,
  hobbies: TAGS.WELLNESS,
  proathletes: TAGS.WELLNESS,
  infographic: TAGS.WELLNESS,
  selfcaresunday: TAGS.WELLNESS,
  visionboard: TAGS.WELLNESS,
  productreviews: TAGS.WELLNESS,
  fragrance: TAGS.WELLNESS,
  sexism: TAGS.WELLNESS,
  eckharttolle: TAGS.WELLNESS,
  sanfrancisco: TAGS.WELLNESS,
  activism: TAGS.WELLNESS,
  goodness: TAGS.WELLNESS,
  rhythm: TAGS.WELLNESS,
  buddhism: TAGS.WELLNESS,
  bully: TAGS.WELLNESS,
  billclinton: TAGS.WELLNESS,
  jenniferaniston: TAGS.WELLNESS,
  london: TAGS.WELLNESS,
  achievement: TAGS.WELLNESS,
  savasana: TAGS.WELLNESS,
  mirandakerr: TAGS.WELLNESS,
  patience: TAGS.WELLNESS,
  barefoot: TAGS.WELLNESS,
  italy: TAGS.WELLNESS,
  peta: TAGS.WELLNESS,
  jealousy: TAGS.WELLNESS,
  transcendental: TAGS.WELLNESS,
  masturbation: TAGS.WELLNESS,
  backtoschool: TAGS.WELLNESS,
  racism: TAGS.WELLNESS,
  longdistancelove: TAGS.WELLNESS,
  reflexology: TAGS.WELLNESS,
  health: TAGS.HEALTH,
  beauty: TAGS.HEALTH,
  weightloss: TAGS.HEALTH,
  greenbeauty: TAGS.HEALTH,
  detox: TAGS.HEALTH,
  diybeauty: TAGS.HEALTH,
  womenshealth: TAGS.HEALTH,
  weightlosssuccess: TAGS.HEALTH,
  aging: TAGS.HEALTH,
  healthyreset: TAGS.HEALTH,
  functionalmedicine: TAGS.HEALTH,
  beautydiary: TAGS.HEALTH,
  disease: TAGS.HEALTH,
  study: TAGS.HEALTH,
  heartdisease: TAGS.HEALTH,
  fat: TAGS.HEALTH,
  goal: TAGS.HEALTH,
  howtoloseweight: TAGS.HEALTH,
  toxic: TAGS.HEALTH,
  hair: TAGS.HEALTH,
  cosmetics: TAGS.HEALTH,
  mentalillness: TAGS.HEALTH,
  eatingdisorder: TAGS.HEALTH,
  death: TAGS.HEALTH,
  bingeeating: TAGS.HEALTH,
  menstruation: TAGS.HEALTH,
  adrenalfatigue: TAGS.HEALTH,
  insomnia: TAGS.HEALTH,
  antioxidant: TAGS.HEALTH,
  cold: TAGS.HEALTH,
  remedy: TAGS.HEALTH,
  backpain: TAGS.HEALTH,
  panicattack: TAGS.HEALTH,
  constipation: TAGS.HEALTH,
  vitamind: TAGS.HEALTH,
  diabetes: TAGS.HEALTH,
  breastcancer: TAGS.HEALTH,
  flu: TAGS.HEALTH,
  salt: TAGS.HEALTH,
  magnesium: TAGS.HEALTH,
  childbirth: TAGS.HEALTH,
  minerals: TAGS.HEALTH,
  alkaline: TAGS.HEALTH,
  pms: TAGS.HEALTH,
  alzheimers: TAGS.HEALTH,
  realtalkinfertility: TAGS.HEALTH,
  celiac: TAGS.HEALTH,
  dentalhealth: TAGS.HEALTH,
  antiaging: TAGS.HEALTH,
  zinc: TAGS.HEALTH,
  vitaminc: TAGS.HEALTH,
  aloe: TAGS.HEALTH,
  calcium: TAGS.HEALTH,
  autism: TAGS.HEALTH,
  sunprotection: TAGS.HEALTH,
  dehydration: TAGS.HEALTH,
  dementia: TAGS.HEALTH,
  cholesterol: TAGS.HEALTH,
  cellulite: TAGS.HEALTH,
  happiness: TAGS.HAPPINESS,
  relationships: TAGS.HAPPINESS,
  love: TAGS.HAPPINESS,
  sex: TAGS.HAPPINESS,
  selfawareness: TAGS.HAPPINESS,
  travel: TAGS.HAPPINESS,
  manifestation: TAGS.HAPPINESS,
  sexuality: TAGS.HAPPINESS,
  productivity: TAGS.HAPPINESS,
  fashion: TAGS.HAPPINESS,
  nature: TAGS.HAPPINESS,
  wellth: TAGS.HAPPINESS,
  holidays: TAGS.HAPPINESS,
  intuition: TAGS.HAPPINESS,
  outdoors: TAGS.HAPPINESS,
  communication: TAGS.HAPPINESS,
  relaxation: TAGS.HAPPINESS,
  work: TAGS.HAPPINESS,
  creativity: TAGS.HAPPINESS,
  declutter: TAGS.HAPPINESS,
  style: TAGS.HAPPINESS,
  art: TAGS.HAPPINESS,
  flowers: TAGS.HAPPINESS,
  traveldiary: TAGS.HAPPINESS,
  compassion: TAGS.HAPPINESS,
  vacation: TAGS.HAPPINESS,
  laughter: TAGS.HAPPINESS,
  food: TAGS.FOOD,
  healthyfoods: TAGS.FOOD,
  recipes: TAGS.FOOD,
  healthyrecipes: TAGS.FOOD,
  foodasmedicine: TAGS.FOOD,
  nutrition: TAGS.FOOD,
  veganrecipes: TAGS.FOOD,
  functionalfoods: TAGS.FOOD,
  glutenfreerecipe: TAGS.FOOD,
  plantbased: TAGS.FOOD,
  functionalrecipes: TAGS.FOOD,
  smoothie: TAGS.FOOD,
  whatieatinaday: TAGS.FOOD,
  cleanfood: TAGS.FOOD,
  chocolate: TAGS.FOOD,
  avocado: TAGS.FOOD,
  water: TAGS.FOOD,
  foods: TAGS.FOOD,
  paleorecipes: TAGS.FOOD,
  juice: TAGS.FOOD,
  thanksgiving: TAGS.FOOD,
  dairy: TAGS.FOOD,
  meat: TAGS.FOOD,
  spices: TAGS.FOOD,
  functionalfood: TAGS.FOOD,
  plantbasednutrition: TAGS.FOOD,
  foodhowto: TAGS.FOOD,
  groceryshopping: TAGS.FOOD,
  fiber: TAGS.FOOD,
  caffeine: TAGS.FOOD,
  cravings: TAGS.FOOD,
  mealprepsunday: TAGS.FOOD,
  wholefoods: TAGS.FOOD,
  chefs: TAGS.FOOD,
  mealplan: TAGS.FOOD,
  chiaseed: TAGS.FOOD,
  juicerecipes: TAGS.FOOD,
  foodguides: TAGS.FOOD,
  farmersmarkets: TAGS.FOOD,
  rawfoodsrecipes: TAGS.FOOD,
  fish: TAGS.FOOD,
  cacao: TAGS.FOOD,
  rawfoods: TAGS.FOOD,
  coconutmilk: TAGS.FOOD,
  wine: TAGS.FOOD,
  ginger: TAGS.FOOD,
  quinoa: TAGS.FOOD,
  seaweed: TAGS.FOOD,
  vinegar: TAGS.FOOD,
  garlic: TAGS.FOOD,
  arganoil: TAGS.FOOD,
  coconutwater: TAGS.FOOD,
  juicing: TAGS.FOOD,
  almondmilk: TAGS.FOOD,
  juicedetox: TAGS.FOOD,
  soy: TAGS.FOOD,
  maca: TAGS.FOOD,
  oliveoil: TAGS.FOOD,
  sodium: TAGS.FOOD,
  michaelpollan: TAGS.FOOD,
  almondbutter: TAGS.FOOD,
  ediblegarden: TAGS.FOOD,
  tahini: TAGS.FOOD,
  pumpkin: TAGS.FOOD,
  parsley: TAGS.FOOD,
  stevia: TAGS.FOOD,
  gojiberries: TAGS.FOOD,
  raw: TAGS.FOOD,
  granola: TAGS.FOOD,
  fitness: TAGS.FITNESS,
  workout: TAGS.FITNESS,
  fitnesssequence: TAGS.FITNESS,
  yogaposes: TAGS.FITNESS,
  training: TAGS.FITNESS,
  runningtips: TAGS.FITNESS,
  trainingadvice: TAGS.FITNESS,
  yogamove: TAGS.FITNESS,
  yogis: TAGS.FITNESS,
  body: TAGS.FITNESS,
  yogasequence: TAGS.FITNESS,
  abs: TAGS.FITNESS,
  yogaphilosophy: TAGS.FITNESS,
  barre: TAGS.FITNESS,
  yogaposerelax: TAGS.FITNESS,
  pregnancyandyoga: TAGS.FITNESS,
  cardio: TAGS.FITNESS,
  yogaposesmoving: TAGS.FITNESS,
  cycling: TAGS.FITNESS,
  spinning: TAGS.FITNESS,
  restorativeyoga: TAGS.FITNESS,
  dance: TAGS.FITNESS,
  yogaformen: TAGS.FITNESS,
  yogaforkids: TAGS.FITNESS,
  yinyoga: TAGS.FITNESS,
  surfing: TAGS.FITNESS,
  skiing: TAGS.FITNESS,
  extremefitness: TAGS.FITNESS,
  snowboarding: TAGS.FITNESS,
  alignment: TAGS.FITNESS,
  yogaposesvideo: TAGS.FITNESS,
  myworkoutroutine: TAGS.FITNESS,
  sweatstyle: TAGS.FITNESS,
  yogaposessequence: TAGS.FITNESS,
  pranayama: TAGS.FITNESS,
  yogateachertraining: TAGS.FITNESS,
  acroyoga: TAGS.FITNESS,
  prenatalyoga: TAGS.FITNESS,
  kathrynbudig: TAGS.FITNESS,
  watersports: TAGS.FITNESS,
  kidsyoga: TAGS.FITNESS,
  spartan: TAGS.FITNESS,
  standuppaddle: TAGS.FITNESS,
  taichi: TAGS.FITNESS,
  yogamatcleaning: TAGS.FITNESS,
  standuppaddleboardyoga: TAGS.FITNESS,
  sweatysaturday: TAGS.FITNESS,
}

export const formatTargetingValue = (value) => {
  const sanitizeString = (str) =>
    String(str)
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "")

  if (Array.isArray(value)) {
    return value.map(sanitizeString)
  }
  return sanitizeString(value)
}

export default (tag) => {
  const key = tag.replace(/[^a-zA-Z]/g, "").toLowerCase()
  return key in tagMap ? tagMap[key] : ""
}
